/**
 * Slug страницы /payments/:streamername с сохранением регистра.
 * Заглавные буквы кодируем (%41…), чтобы URL не «схлопывался» в lowercase в браузере.
 */

export function encodePaymentsStreamerSlug(username) {
  const raw = String(username || "").trim();
  if (!raw) return "";
  return raw.replace(/[A-Z]/g, (char) => {
    const hex = char.charCodeAt(0).toString(16).toUpperCase();
    return `%${hex.padStart(2, "0")}`;
  });
}

export function decodePaymentsStreamerSlug(slug) {
  const raw = String(slug || "").trim();
  if (!raw) return "";
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}

export function buildPaymentsPagePath(username) {
  const slug = encodePaymentsStreamerSlug(username);
  if (!slug) return "";
  return `/payments/${slug}`;
}

export function buildPaymentsPageUrl(username, origin) {
  const path = buildPaymentsPagePath(username);
  if (!path) return "";
  const base = String(origin || "").trim().replace(/\/+$/, "");
  if (!base) return path;
  return `${base}${path}`;
}

export function streamerSlugFromPathname(pathname) {
  const match = String(pathname || "").match(/^\/payments\/([^/?#]+)/);
  if (!match) return "";
  return decodePaymentsStreamerSlug(match[1]);
}
